const QueueRandomized = require('QueueRandomized');
const CameraController = require('CameraController');
cc.Class({
    extends: cc.Component,

    properties: {
        spine: sp.Skeleton,
        animations: [cc.String],
        randomized: false,
        freq: {
            default: 1,
            visible: function() { return this.randomized }
        },
        skew: {
            default: 1,
            visible: function() { return this.randomized }
        },
        playOnEnable: true,
    },

    onLoad () {
        if (!this.playOnEnable) {
            this.spine.node.active = false;
        }
        if (!this.animations.length) {
            this.node.removeComponent(this);
            return;
        }
        if (!this.spine) {
            this.spine = this.node.getComponent(sp.Skeleton);
        }
        if (!this.spine) {
            this.spine = this.node.getComponentInChildren(sp.Skeleton);
        }
        if (this.randomized) {
            this.animQueue = new QueueRandomized(this.animations, this.freq, this.skew);
        } else {
            this.animIndex = 0;
        }

        if (this.animations.length > 1) {
            this.spine.setCompleteListener(() => {
                this.playAnimations();
            });
        }
    },

    onEnable() {
        if (this.playOnEnable) {
            this.play();
        }
    },


    playAnimations () {
        if (this.randomized) {
            this.spine.setAnimation(0, this.animQueue.getNext(), false);
        } else if (this.animations.length === 1) {
            this.spine.setAnimation(0, this.animations[0], true);
        } else {
            this.spine.setAnimation(0, this.animations[this.animIndex], false);
            this.animIndex = (this.animIndex + 1) & this.animations.length;
        }
    },

    play () {
        this.spine.node.active = true;

        this.playAnimations();
    }
});
